import { FaWhatsapp } from "react-icons/fa";
import { StoreSettings } from "../types";

const WhatsAppFloatButton = ({ store_settings }: { store_settings: StoreSettings }) => {
  if (!store_settings?.whatsapp_number) return null;

  return (
    <a
      href={`https://wa.me/${store_settings.whatsapp_number}`}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-lg transition-all duration-300 hover:scale-110 hover:shadow-xl group"
      aria-label="Contactar por WhatsApp"
    >
      <FaWhatsapp className="h-6 w-6" />
      <div className="absolute right-full mr-3 top-1/2 transform -translate-y-1/2 bg-gray-800 text-white px-3 py-2 rounded-lg text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
        ¡Cotiza ahora!
        <div className="absolute left-full top-1/2 transform -translate-y-1/2 border-4 border-transparent border-l-gray-800"></div>
      </div>
    </a>
  );
};

export default WhatsAppFloatButton;